import { supabase } from '../lib/supabase';
import type { RadarRole } from '../types/app';
import { loadAssessments, loadTeacherClassIds, type Assessment } from './assessments';
import { loadClasses, loadStudents, type RadarClass, type RadarStudent } from './registry';
import { loadLaunchResults, type LaunchResult } from './launches';

export type SkillResult={
  school_id:string;class_id:string;student_id:string;assessment_id:string;matrix_item_id:string|null;
  code:string|null;skill:string|null;description:string|null;questions_evaluated:number|null;correct_answers:number|null;percentage:number|null;
};
export type ReportData={classes:RadarClass[];students:RadarStudent[];assessments:Assessment[];launches:LaunchResult[];skills:SkillResult[]};

function sb(){if(!supabase)throw new Error('Supabase nÃ£o configurado.');return supabase;}
export function resultBand(value:number|null|undefined){const n=Number(value??0);return n<=40?{label:'Prioridade',key:'priority'}:n<=60?{label:'Em desenvolvimento',key:'development'}:{label:'Aprendizagem adequada',key:'adequate'};}
export function meanPct(rows:{percentage:number|null}[]){return rows.length?Math.round(rows.reduce((s,r)=>s+Number(r.percentage||0),0)/rows.length):null;}
export function dedupeLaunches(rows:LaunchResult[]){const map=new Map<string,LaunchResult>();for(const r of [...rows].sort((a,b)=>String(b.submitted_at||'').localeCompare(String(a.submitted_at||'')))){const k=`${r.assessment_id}|${r.student_id}`;if(!map.has(k))map.set(k,r);}return [...map.values()];}
export function groupedSkills(rows:SkillResult[]){const m=new Map<string,{code:string;skill:string;description:string;questions:number;correct:number}>();for(const r of rows){const code=String(r.code||'â€”');const k=`${code}|${r.skill||''}|${r.description||''}`;const cur=m.get(k)||{code,skill:String(r.skill||'Habilidade avaliada'),description:String(r.description||''),questions:0,correct:0};cur.questions+=Number(r.questions_evaluated||0);cur.correct+=Number(r.correct_answers||0);m.set(k,cur);}return [...m.values()].map(x=>({...x,pct:x.questions?Math.round(x.correct/x.questions*100):0}));}
export function learningDistribution(rows:LaunchResult[]){const out=[{key:'priority',label:'Prioridade',count:0,pct:0},{key:'development',label:'Em desenvolvimento',count:0,pct:0},{key:'adequate',label:'Aprendizagem adequada',count:0,pct:0}];for(const r of rows){const b=resultBand(Number(r.percentage||0));out.find(x=>x.key===b.key)!.count++;}for(const x of out)x.pct=rows.length?Math.round(x.count/rows.length*100):0;return out;}

export async function loadReportData(schoolId:string,role:RadarRole):Promise<ReportData>{
  const [classes,students,assessments,launches]=await Promise.all([
    loadClasses(schoolId),
    loadStudents(schoolId),
    loadAssessments(schoolId,role),
    loadLaunchResults(schoolId,role)
  ]);

  let teacherClassIds:string[]=[];

  if(role==='teacher'){
    teacherClassIds=await loadTeacherClassIds();

    if(!teacherClassIds.length){
      return {
        classes:[],
        students:[],
        assessments,
        launches,
        skills:[]
      };
    }
  }

  const skillBatches=await Promise.all(
    assessments.map(async assessment=>{
      let skillQ=sb()
        .from('student_skill_results')
        .select('*')
        .eq('school_id',schoolId)
        .eq('assessment_id',assessment.id)
        .order('class_id',{ascending:true})
        .order('student_id',{ascending:true})
        .order('code',{ascending:true});

      if(role==='teacher'){
        skillQ=skillQ.in('class_id',teacherClassIds);
      }

      const {data,error}=await skillQ;

      if(error){
        throw error;
      }

      return (data||[]) as SkillResult[];
    })
  );

  const skills=skillBatches.flat();

  const allowedClassIds=
    role==='teacher'
      ? new Set(teacherClassIds)
      : null;

  return {
    classes:allowedClassIds
      ? classes.filter(c=>allowedClassIds.has(c.id))
      : classes,

    students:allowedClassIds
      ? students.filter(s=>allowedClassIds.has(s.class_id))
      : students,

    assessments,

    launches:dedupeLaunches(launches),

    skills
  };
}
